import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { id: "tab-headers" }
const _hoisted_2 = { class: "rowcenter w-full" }
const _hoisted_3 = {
  key: 0,
  class: "row headerDate"
}
const _hoisted_4 = {
  key: 0,
  class: "row w-full gap-04"
}
const _hoisted_5 = {
  key: 1,
  class: "row w-full gap-04"
}
const _hoisted_6 = { class: "rowcenter w-full" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "rowend headerNavigation"
}
const _hoisted_9 = { id: "active-tab" }

import { ref, computed, onMounted  } from 'vue';
import StringService from '@/services/StringService';
import DateService from '@/services/DateService';
import { useI18n } from 'vue-i18n';
import SharedService from '@/services/SharedService';
import { isToday } from "date-fns";
import { useAppUserStore } from '@/stores/appUser';
import { getLocaleForJs } from '@/utils/date-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'tabs',
  props: {
    showCalendarHeader: { type: Boolean, default: false },
    weekCalendarHeader: { type: Boolean },
    selectedDate: {},
    titles: {},
    isSettings: { type: Boolean }
  },
  emits: ['changeTab', 'redirectToday', 'leftNavigation', 'rightNavigation'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const { t } = useI18n();
const emits = __emit;
const appUserStore = useAppUserStore();
const weekDate = appUserStore.getCurrentAgendaType() ? (Number.parseInt(appUserStore.getCurrentAgendaType()) === 1 ? ref(true) : ref(false)) : ref(true);
let tabContainer = ref(null);
let tabHeaders = ref(null);
let tabs = ref(null);
let activeTabIndex = ref(0);

onMounted(() => {
 tabs.value = [...tabContainer.value.querySelectorAll('.tab')];

  for (let x of tabs.value) {
    if (x.classList.contains('active')) {
      activeTabIndex.value = tabs.value.indexOf(x);
    }
  }
});


const changeTab = (index: number) => {
  if (!props.isSettings) {
    appUserStore.updateCurrentAgendaType(index);
  }
    
  for (let x of [...tabs.value, ...tabHeaders.value]) {
      x.classList.remove('active');
  }
  tabs.value[index].classList.add('active');
  tabHeaders.value[index].classList.add('active');

  weekDate.value = index !== 0;

  emits('changeTab', index);
}

const locale = computed(() => {
  const menuLanguageIso = appUserStore?.currentAppUserData?.preferences.menuLanguageIso;
  return getLocaleForJs(menuLanguageIso);
});

const getIcon = (icon: string, isFillIcon: boolean, subPath: string) => {
  return SharedService.getIcon(icon, isFillIcon, subPath);
};

const getSelectedMonth = () => {
  return StringService.capitalize(DateService.getLastDayOfWeek(props.selectedDate, true).toLocaleDateString(locale.value, DateService.getFormatOptionMonth()));
}

const getSelectedMonthForDayView = () => {
  return StringService.capitalize(props.selectedDate.toLocaleDateString(locale.value, DateService.getFormatOptionMonth()));
}

const getSelectedWeek = () => {
  return t('calendar.header.weekDays', 
                                {first:  DateService.getFirstDayOfWeek(props.selectedDate, true).toLocaleDateString(locale.value, DateService.getFormatOptionDay()), 
                                last:  DateService.getLastDayOfWeek(props.selectedDate, true).toLocaleDateString(locale.value, DateService.getFormatOptionDay())});
}

const getSelectedDay = () => {
  return StringService.capitalize(props.selectedDate.toLocaleDateString(locale.value, DateService.getFormatOptionLongDay()));
}

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_button_navigation = _resolveComponent("es-button-navigation")!

  return (_openBlock(), _createElementBlock("div", {
    id: "tabs-container",
    class: _normalizeClass('customClass'),
    ref_key: "tabContainer",
    ref: tabContainer
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showCalendarHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_unref(weekDate))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_text_item, {
                      txt: getSelectedWeek(),
                      styles: "font-lBold",
                      class: "txt-grey-64"
                    }, null, 8, ["txt"]),
                    _createVNode(_component_text_item, {
                      txt: getSelectedMonth(),
                      styles: "font-lBold"
                    }, null, 8, ["txt"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_text_item, {
                      txt: getSelectedDay(),
                      styles: "font-lBold",
                      class: _normalizeClass(_unref(isToday)(props.selectedDate) ?'txt-red' : 'txt-grey-64')
                    }, null, 8, ["txt", "class"]),
                    _createVNode(_component_text_item, {
                      txt: getSelectedMonthForDayView(),
                      styles: "font-lBold"
                    }, null, 8, ["txt"])
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: _normalizeClass(_unref(activeTabIndex) === index ? 'active' : ''),
                onClick: ($event: any) => (changeTab(Number(index))),
                ref_for: true,
                ref_key: "tabHeaders",
                ref: tabHeaders
              }, _toDisplayString(props.titles[Number(index)]), 11, _hoisted_7))
            }), 128))
          ])
        ]),
        (_ctx.showCalendarHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_es_button_navigation, {
                iconLeft: getIcon('chevron-left', false, 'navigationIcons'),
                altLeft: _unref(t)('calendar.header.pastButton'),
                iconRight: getIcon('chevron-right', false, 'navigationIcons'),
                altRight: _unref(t)('calendar.header.nextButton'),
                styles: "mleft-05",
                buttonLabel: _unref(t)('calendar.header.todayButton'),
                onClickRight: _cache[0] || (_cache[0] = ($event: any) => (emits('rightNavigation'))),
                onClickLeft: _cache[1] || (_cache[1] = ($event: any) => (emits('leftNavigation'))),
                onClickButton: _cache[2] || (_cache[2] = ($event: any) => (emits('redirectToday')))
              }, null, 8, ["iconLeft", "altLeft", "iconRight", "altRight", "buttonLabel"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 512))
}
}

})